import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AppContext from '../../context';
var PdfViewer = /*#__PURE__*/function (_React$Component) {
  _inherits(PdfViewer, _React$Component);
  var _super = _createSuper(PdfViewer);
  function PdfViewer() {
    var _this;
    _classCallCheck(this, PdfViewer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isComponentsLoaded: false,
      numPages: null
    });
    _defineProperty(_assertThisInitialized(_this), "Document", null);
    _defineProperty(_assertThisInitialized(_this), "Page", null);
    _defineProperty(_assertThisInitialized(_this), "onDocumentLoaded", function (_ref) {
      var numPages = _ref.numPages;
      _this.setState({
        numPages: numPages
      });
    });
    return _this;
  }
  _createClass(PdfViewer, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$import, pdfjs, Page, Document;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!!window && window !== 'undefined')) {
                _context.next = 11;
                break;
              }
              _context.next = 3;
              return import('react-pdf');
            case 3:
              _yield$import = _context.sent;
              pdfjs = _yield$import.pdfjs;
              Page = _yield$import.Page;
              Document = _yield$import.Document;
              pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();
              this.Document = Document;
              this.Page = Page;
              // eslint-disable-next-line react/no-did-mount-set-state
              this.setState({
                isComponentsLoaded: true
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        isComponentsLoaded = _this$state.isComponentsLoaded,
        numPages = _this$state.numPages;
      var _this$props = this.props,
        fileUrl = _this$props.fileUrl,
        className = _this$props.className,
        pageWidth = _this$props.pageWidth;
      var Document = this.Document,
        Page = this.Page;
      if (!isComponentsLoaded) {
        return null;
      }
      return /*#__PURE__*/_jsx(Document, {
        file: fileUrl,
        className: classNames(className),
        onLoadSuccess: this.onDocumentLoaded
      }, void 0, Array.apply(null, Array(numPages)).map(function (x, i) {
        return i + 1;
      }).map(function (page, index) {
        return /*#__PURE__*/_jsx(Page, {
          width: pageWidth,
          style: {
            maxWidth: '100%'
          },
          className: classNames(className),
          renderTextLayer: false,
          renderAnnotationLayer: false,
          pageNumber: page
          // eslint-disable-next-line react/no-array-index-key
        }, "page-number-".concat(index));
      }));
    }
  }]);
  return PdfViewer;
}(React.Component);
_defineProperty(PdfViewer, "contextType", AppContext);
_defineProperty(PdfViewer, "defaultProps", {
  pageWidth: '1366'
});
export { PdfViewer as default };